import { IntensityCategory } from '../models/IntensityCategory';
import { RankingItem } from '../models/RankingItem';
import apiClient from './apiClient';
import { NetworkError, UnauthorizedError, ForbiddenError, NotFoundError, ApiError } from './errors';

export const fetchRanking = async (
  wodId: number,
  intensityCategoryId: number,
  ratingTypeId: number,
): Promise<RankingItem[]> => {
  try {
    const url = `/ratings/ranking/block/${wodId}/intensity-category/${intensityCategoryId}/rating-type/${ratingTypeId}`;
    const { data } = await apiClient.get<{
      success: boolean;
      status: number;
      data: RankingItem[];
    }>(url);
    return data.data;
  } catch (err: any) {
    if (err.isAxiosError) {
      if (!err.response) throw new NetworkError(err.message);
      switch (err.response.status) {
        case 401:
          throw new UnauthorizedError();
        case 403:
          throw new ForbiddenError();
        case 404:
          throw new NotFoundError();
        default:
          throw new ApiError(err.response.status, err.message);
      }
    }
    throw err;
  }
};

export const fetchIntensityCategories = async (): Promise<IntensityCategory[]> => {
  try {
    const { data } = await apiClient.get<{
      success: boolean;
      status: number;
      data: IntensityCategory[];
    }>('/ratings/intensity-categories');
    return data.data;
  } catch (err: any) {
    if (err.isAxiosError) {
      if (!err.response) throw new NetworkError(err.message);
      switch (err.response.status) {
        case 401:
          throw new UnauthorizedError();
        case 403:
          throw new ForbiddenError();
        case 404:
          throw new NotFoundError();
        default:
          throw new ApiError(err.response.status, err.message);
      }
    }
    throw err;
  }
};
